import { memo } from 'react';

import { Link } from '@tanstack/react-router';
import { twMerge } from 'tailwind-merge';

import { Avatar, AvatarFallback, AvatarImage } from '@/_components';
import { DeleteButton } from '@/_containers';
import type { TeamMemberQueryLinkerSchema } from '@/_schemas/team-members/team-members-query-linker-schema';
import { nameResolver } from '@/_shared';

type TeamMemberItemProps = {
  item: TeamMemberQueryLinkerSchema;
  removeItemHandler: (item: TeamMemberQueryLinkerSchema) => void;
  isEditable?: boolean;
  className?: string;
};

function ItemBase({ item, isEditable = false, removeItemHandler, className }: TeamMemberItemProps) {
  const handleDeleteContact = async () => {
    removeItemHandler(item);
  };

  return (
    <section
      className={twMerge(
        'border-c-border-muted text-accent flex min-h-11 flex-1 flex-col flex-nowrap items-start justify-between gap-1.5 border-b py-2 sm:flex-row dark:text-white',
        className
      )}
    >
      <div className="flex w-full items-center gap-1.5">
        <Link
          to="/team-members/$id"
          params={{ id: `${item.id}` }}
          state={{ naturalBack: true }}
          className="group flex items-center gap-2"
        >
          <Avatar>
            <AvatarImage src={item.profile_image?.[0]?.url} />
            <AvatarFallback name={nameResolver(item.first_name, item.last_name)} />
          </Avatar>

          <span className="decoration-primary text-sm decoration-2 group-hover:underline">
            {item.first_name} {item.last_name}
          </span>
        </Link>
      </div>
      {isEditable && (
        <DeleteButton
          type="icon"
          size="sm"
          title="Remove Contact?"
          text="The Contact record will not be deleted; only its association will be removed."
          yesButton="Yes, Remove"
          aria-label="Remove contact"
          callback={handleDeleteContact}
        />
      )}
    </section>
  );
}

export const Item = memo(ItemBase);
